import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="rounded-2xl overflow-hidden bg-background-50 border border-background-200/70">
          <div className="flex flex-col lg:flex-row">
            <div className="flex-1 p-8 md:p-14 flex flex-col justify-center">
              <p className="text-sm text-primary-600 font-semibold tracking-wide uppercase">
                随时随地 畅享韩漫
              </p>
              <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-foreground-950 mt-3 leading-tight">
                加入<em className="not-italic text-primary-500">爱漫画</em>
                <br />
                开启你的韩漫之旅
              </h2>
              <p className="mt-5 text-foreground-600 text-base md:text-lg max-w-md leading-relaxed">
                2000+ 部优质韩漫等你来读，每日更新不断档。下拉式阅读体验，让你沉浸在精彩的漫画世界中。
              </p>
              <div className="mt-8 flex flex-col sm:flex-row gap-3">
                <Link
                  to="/category/fantasy"
                  className="whitespace-nowrap px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer text-center"
                >
                  立即开始阅读
                </Link>
                <Link
                  to="/about"
                  className="whitespace-nowrap px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 text-base font-medium hover:border-primary-300 hover:text-primary-600 transition-all cursor-pointer text-center"
                >
                  关于我们
                </Link>
              </div>
            </div>
            <div className="flex-1 min-h-[300px] lg:min-h-[400px]">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20cozy%20scene%20of%20a%20person%20reading%20a%20Korean%20manhwa%20on%20a%20tablet%20in%20a%20comfortable%20setting%2C%20soft%20natural%20lighting%20from%20a%20window%2C%20minimalist%20modern%20interior%20with%20plants%20and%20warm%20textures%2C%20relaxing%20atmosphere%2C%20artistic%20photography%20style%20with%20soft%20shadows%20and%20warm%20tones%2C%20clean%20composition&width=1000&height=700&seq=cta-section-img&orientation=landscape"
                alt="在爱漫画阅读韩漫"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}